import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { CANONICAL_BASE_URL, getRouteSeoMeta } from '../../config/routeSeo';

const RouteSeoPolicy = () => {
  const location = useLocation();
  const routeSeoMeta = getRouteSeoMeta(location.pathname);

  if (routeSeoMeta.robots !== 'noindex,nofollow') {
    return null;
  }

  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex, nofollow" />
      <link rel="canonical" href={`${CANONICAL_BASE_URL}${routeSeoMeta.canonicalPath}`} />
    </Helmet>
  );
};

export default RouteSeoPolicy;
